class ProductFormVariants extends HTMLElement {
  constructor() {
    super();

    const elements = {
      form: this.closest('form'),
      inputs: this.querySelectorAll('input[type="radio"]')
    };

    const get_variant = () => {
      const variant_title = get_variant_title(elements.inputs);
      const variant = get_variant_by_title(variant_title);
      return variant;
    };

    const get_variant_title = (form_elements) => {
      let selectedValues = [];
      form_elements.forEach((el) => {
        if (el.type === 'radio' && el.checked) {
          selectedValues.push(el.value);
        }
      });
      const title = selectedValues.join(' / ').trim();
      return title;
    };

    const get_variant_by_title = (title) => {
      return Theme.Liquid.product.variants.find((variant) => variant.title === title) || null;
    };

    elements.inputs.forEach((input) => {
      input.addEventListener('change', () => {
        const optionValues = input.closest('.option-values');
        const variantOptions = optionValues?.querySelectorAll('.product-form-variant');
        const selectedInput = optionValues?.querySelector('input[type="radio"]:checked');
        const selectedVariantOption = selectedInput?.closest('.product-form-variant');

        if (variantOptions) {
          variantOptions.forEach((option) => {
            option.classList.remove('selected');
          });
        }

        if (selectedVariantOption) {
          selectedVariantOption.classList.add('selected');
        }

        const variant = get_variant();

        if (!variant) {
          this.updateSubmitButton(null);
          return;
        }

        document.dispatchEvent(new CustomEvent('productformvariants:change', {
          detail: {
            variant: variant
          }
        }));

        Theme.URLParams.set('variant', variant.id);

        if (elements.form?.querySelector('[name="id"]')) {
          elements.form.querySelector('[name="id"]').value = variant.id;
        }

        this.updateSubmitButton(variant);
      });
    });
  }

  updateSubmitButton(variant) {
    const form = this.closest('form');
    const submitButton = form?.querySelector('[data-product-submit-button]');
    const submitText = form?.querySelector('[data-product-submit-text]');

    if (!submitButton || !submitText) {
      return;
    }

    if (!variant) {
      submitButton.disabled = true;
      submitText.textContent = submitButton.dataset.selectLabel;
      return;
    }

    submitButton.disabled = !variant.available;
    submitText.textContent = variant.available ? submitButton.dataset.addLabel : submitButton.dataset.soldOutLabel;
  }
}

customElements.define('product-form-variants', ProductFormVariants);
